export const T = {
  fr: {
    nav: { products: "La Gamme", ritual: "Le Rituel", story: "Philosophie", contact: "Contact" },
    cart: "Panier",
    hero: {
      overline: "Adaptogenic Swiss Rituals",
      line1: "L'énergie",
      line2: "sans le crash.",
      line3: "Le calme",
      line4: "sans la fatigue.",
      sub: "Quatre boissons, quatre moments de la journée. Des recettes courtes, sans sucre ajouté, où le cacao, le café, le matcha et les épices rencontrent des extraits de champignons adaptogènes.",
      cta1: "Découvrir notre gamme",
      cta2: "Notre philosophie",
      badge1: "Sans sucre ajouté",
      badge2: "5 à 7 ingrédients",
      badge3: "Extraits purs",
      quote: "\"À chaque moment son rituel.\"",
      quoteSub: "Quatre rituels, quatre moments",
    },
    marquee: ["Sans sucre ajouté", "Recettes courtes : 5 à 7 ingrédients", "Extraits purs, pas de poudre de mycélium", "Lion's Mane · Cordyceps · Reishi · Tremella", "Livraison offerte dès 50 CHF"],
    products: {
      overline: "Le Cycle de la Journée",
      title: "À chaque moment son rituel.",
      add: "Ajouter au panier",
      added: "Ajouté au panier",
      from: "CHF",
      soldOut: "Rupture de stock",
      soldOutNote: "Bientôt de retour — inscrivez-vous pour être averti·e.",
      preorder: "Précommande",
      preorderNote: "Article en précommande : expédié dès sa disponibilité, vous serez informé·e par email.",
    },
    checkoutPage: {
      title: "Finaliser ma commande",
      step1: "Identification",
      step2: "Adresse de livraison",
      guest: "Commander en tant qu'invité·e",
      guestSub: "Sans créer de compte — vous recevrez tout par email.",
      login: "J'ai déjà un compte",
      loginSub: "Retrouvez vos adresses et suivez vos commandes.",
      loggedAs: "Connecté·e en tant que",
      change: "Changer",
      phone: "Téléphone (optionnel, pour le transporteur)",
      line1: "Rue et numéro",
      line2: "Complément (étage, c/o…)",
      zip: "NPA",
      city: "Localité",
      country: "Pays",
      note: "Remarque pour la livraison (optionnel)",
      saveAddress: "Enregistrer cette adresse dans mon compte",
      summary: "Récapitulatif",
      pay: "Continuer vers le paiement",
      step3: "Paiement sécurisé",
      edit: "Modifier",
      shipTo: "Livraison à",
      secure: "Paiement chiffré et traité par Stripe (carte, TWINT, Apple Pay). Aucune donnée bancaire ne transite par nos serveurs.",
      payUnavailable: "Paiement momentanément indisponible — réessayez dans un instant.",
      empty: "Votre panier est vide.",
      chOnly: "Nous livrons actuellement en Suisse uniquement.",
      subscription: "Abonnement mensuel",
      promoHint: "Un code promo ? Vous pourrez le saisir à l'étape de paiement.",
      reassurance: [
        "Paiement 100 % sécurisé — Stripe, 3D Secure",
        "Expédition depuis la Suisse sous 2–3 jours ouvrés, colis suivi",
        "Retours acceptés sous 14 jours sur les sachets non ouverts",
        "Sans sucre ajouté — Érythritol bio, Maca et Lucuma, jamais de sucre raffiné",
        "Confirmation et suivi envoyés par email à chaque étape",
      ],
    },
    manifesto: {
      overline: "Notre Philosophie",
      title: "Une tasse pour chaque moment de la journée.",
      chapters: [
        { num: "01", title: "Notre point de départ", text: "Un café à 8 h, un deuxième à 11 h, un troisième à 14 h — et malgré tout le mur de la fin d'après-midi. La caféine ne crée pas d'énergie : elle masque la fatigue, puis tout revient d'un coup. Nous avons voulu l'inverse d'une course aux stimulants : une tasse par moment de la journée, formulée pour ce moment précis." },
        { num: "02", title: "Zéro sucre, sans concession", text: "Aucune de nos recettes ne contient de sucre ajouté. L'érythritol sucre pour une valeur énergétique quasi nulle, la maca apporte le caramel, le lucuma la vanille. Des listes courtes de cinq à sept ingrédients, formulées et contrôlées en Suisse selon une législation alimentaire parmi les plus exigeantes." },
        { num: "03", title: "Le choix des champignons", text: "Nos extraits viennent des forêts de Finlande : climat froid, sols acides, règles alimentaires européennes strictes. Un champignon absorbe ce qui l'entoure — la qualité d'un extrait commence donc par celle du sol et de l'eau. Nous parlons de goût, d'origine et de moment ; jamais de promesses d'effet." },
      ],
    },
    ritual: {
      overline: "Le Geste",
      title: "Comment préparer votre rituel.",
      steps: [
        { t: "Dosez", d: "8 g pour un cacao ou un golden milk, 5 g pour Deep Flow, 4 g pour le matcha." },
        { t: "Versez", d: "150 à 200 ml d'eau chaude (80 °C pour le matcha) ou de lait végétal." },
        { t: "Fouettez", d: "15 secondes pour une mousse fine — le geste qui fait le rituel." },
        { t: "Savourez", d: "Morning Focus au lever, Deep Flow à l'effort, Matcha Zen l'après-midi, Evening Calming au coucher." },
      ],
    },
    cartDrawer: {
      title: "Votre panier",
      empty: "Votre panier est vide.",
      emptySub: "Commencez votre rituel avec l'une de nos quatre formulations.",
      freeShippingReached: "Livraison offerte en Suisse",
      freeShippingLeft: (x) => `Plus que ${x} CHF pour la livraison offerte`,
      promo: "Code promo",
      promoApply: "Appliquer",
      promoOk: "Code NURA10 appliqué : −10%",
      promoBad: "Code invalide",
      subtotal: "Sous-total",
      discount: "Remise",
      shipping: "Livraison",
      free: "Offerte",
      total: "Total (TVA incl.)",
      checkout: "Passer commande",
      continueShopping: "Continuer mes achats",
    },
    checkout: {
      title: "Finaliser la commande",
      demo: "",
      name: "Nom complet",
      email: "Email",
      address: "Adresse",
      city: "Ville",
      zip: "NPA",
      payment: "Méthode de paiement",
      card: "Carte de crédit",
      pay: (x) => `Payer ${x} CHF`,
      back: "Retour au panier",
      confirmedTitle: "Merci pour votre commande !",
      confirmedSub: "Votre commande est en préparation.",
      orderNum: "Commande",
      close: "Fermer",
      required: "Veuillez remplir tous les champs",
    },
    contact: {
      overline: "Nous Écrire",
      title: "Une question, un partenariat ?",
      name: "Votre nom",
      email: "Votre email",
      subject: "Sujet",
      subjects: ["Demande produit", "Presse", "Partenariat", "Autre"],
      message: "Votre message",
      send: "Envoyer le message",
      success: "Message envoyé — nous vous répondons dès que possible.",
    },
    newsletter: {
      title: "Rejoignez le cercle NŪRA",
      sub: "Nouvelles formulations, retours en stock et coulisses de la marque — occasionnellement, jamais plus d'une fois par mois.",
      placeholder: "votre@email.ch",
      cta: "S'inscrire",
      success: "Bienvenue dans le cercle NŪRA.",
      already: "Vous êtes déjà inscrit·e.",
    },
    sub: {
      once: "Achat unique",
      monthly: "Abonnement mensuel",
      perMonth: "/mois",
      save: "−10% · Livraison offerte",
      note: "Sans engagement — résiliable à tout moment depuis votre espace client.",
      cta: "S'abonner",
    },
    stockAlert: {
      title: "Prévenez-moi du retour",
      placeholder: "votre@email.ch",
      cta: "Prévenez-moi",
      success: "C'est noté — vous recevrez un email dès le retour en stock.",
      already: "Vous êtes déjà inscrit·e pour ce produit.",
      error: "Erreur — veuillez réessayer.",
    },
    crossSell: {
      title: "Complétez votre cycle",
      add: "Ajouter",
    },
    trust: ["Paiement sécurisé par Stripe", "Livraison en Suisse · offerte dès 50 CHF", "Retours 14 jours (non ouvert)"],
    account: {
      title: "Espace Client",
      login: "Connexion",
      register: "Créer un compte",
      name: "Nom complet",
      email: "Email",
      password: "Mot de passe (min. 8 caractères)",
      loginCta: "Se connecter",
      registerCta: "Créer mon compte",
      hint: "Utilisez l'email de vos commandes pour retrouver votre historique.",
      welcome: "Bienvenue chez NŪRA",
      hello: "Bonjour",
      logout: "Déconnexion",
      orders: "Mes commandes",
      noOrders: "Aucune commande pour le moment.",
      noOrdersHint: "Votre premier rituel vous attend dans la boutique.",
      tracking: "Suivi",
      subscription: "Abonnement",
      statuses: { confirmed: "Confirmée", preparing: "Préparation", shipped: "Expédiée", delivered: "Livrée", cancelled: "Annulée", refunded: "Remboursée" },
      track: "Suivre mon colis",
      profile: "Mon adresse de livraison",
      save: "Enregistrer",
      saved: "Adresse enregistrée",
      review: "Laisser un avis",
      reviewFor: "Votre avis sur",
      reviewPlaceholder: "Goût, préparation, moment de dégustation… (10 caractères min.)",
      reviewSend: "Publier mon avis",
      reviewThanks: "Merci ! Votre avis sera publié après relecture.",
      reviewDone: "Avis envoyé",
      reviewPending: "en attente de relecture",
      reviewPublished: "publié",
    },
    productPage: {
      back: "Retour à la gamme",
      benefits: "Ce que vous allez ressentir",
      ingredients: "Formulation transparente",
      ingredientsNote: "Liste indicative — la liste légale complète et les valeurs nutritionnelles figurent sur l'emballage.",
      preparation: "Préparation",
      reviews: "Avis clients",
      noReviews: "Pas encore d'avis publié pour ce produit. Soyez le premier·ère à partager le vôtre.",
    },
    reviews: {
      overline: "Avis Clients",
      title: "Des avis relus, jamais inventés.",
      intro: "Chaque avis publié ici a été écrit par un·e client·e et relu avant publication. Le badge « Achat vérifié » indique que l'email correspond à une commande livrée. Nous n'achetons ni n'inventons aucun témoignage.",
      empty: "Pas encore d'avis publié.",
      emptySub: "Vous avez goûté nos formulations ? Laissez votre avis depuis la page du produit.",
      verified: "Achat vérifié",
    },
    reviewForm: {
      cta: "Laisser un avis",
      note: "Votre avis sera relu avant publication. Si votre email correspond à une commande livrée, il portera le badge « Achat vérifié ». Seul votre prénom et l'initiale de votre nom sont affichés.",
      name: "Votre nom",
      email: "Votre email (non publié)",
      placeholder: "Goût, préparation, moment de dégustation… (10 caractères min.)",
      send: "Envoyer mon avis",
      thanks: "Merci ! Votre avis sera publié après relecture.",
      error: "Erreur — veuillez réessayer.",
    },
    payment: {
      verifying: "Vérification du paiement…",
      successTitle: "Merci pour votre commande !",
      successSub: "Votre commande est en préparation. Un email de confirmation vous a été envoyé.",
      accountHint: "Suivez votre colis et laissez un avis après livraison : créez un compte avec l'email utilisé au paiement.",
      orderNum: "Commande",
      errorTitle: "Paiement non confirmé",
      errorSub: "Nous n'avons pas pu confirmer votre paiement. Contactez-nous si vous avez été débité.",
      cancelTitle: "Paiement annulé",
      cancelSub: "Votre panier vous attend — aucun montant n'a été débité.",
      backHome: "Retour à la boutique",
    },
    info: {
      title: "Informations",
      lead: "L'essentiel en trois blocs : comment nous livrons, qui édite ce site, et ce que nous faisons de vos données. Les documents complets sont liés dans chaque bloc.",
      foot: "Denrées alimentaires. La liste légale complète des ingrédients, les allergènes et les valeurs nutritionnelles figurent sur chaque emballage. Nos descriptions ne constituent pas des allégations de santé.",
      shipping: {
        h: "Livraison & retours",
        p: [
          "Nous expédions depuis la Suisse. Les frais de port sont de 7 CHF ; ils sont offerts dès 50 CHF d'achat (après remise éventuelle). Les abonnements sont toujours livrés sans frais.",
          "Les commandes sont préparées sous 1 à 2 jours ouvrables et remises à La Poste Suisse. Vous recevez un email de confirmation au paiement, puis un second email avec le numéro de suivi au départ du colis. Le suivi est aussi visible dans votre espace client.",
          "Retours : vous disposez de 14 jours après réception pour nous retourner un sachet non ouvert, dans son emballage d'origine. Écrivez-nous d'abord via le formulaire de contact ; le remboursement est effectué sur le moyen de paiement utilisé. Pour des raisons d'hygiène, les sachets ouverts ne sont pas repris. Un produit endommagé à la livraison est remplacé ou remboursé.",
        ],
      },
      legal: {
        h: "Mentions légales",
        p: [
          "Ce site est édité par NŪRA, canton de Vaud, Suisse. Exploitation en raison individuelle ; société à responsabilité limitée en cours de constitution. Contact : contact@nura-coffee.com.",
          "Les prix sont indiqués en francs suisses (CHF), TVA incluse le cas échéant. Le paiement est traité par Stripe ; NŪRA ne stocke aucune donnée de carte bancaire.",
          "Nos produits sont des denrées alimentaires, formulées sans sucre ajouté. Les descriptions portent sur la composition, le goût et le moment de dégustation — pas sur des effets thérapeutiques. Elles ne remplacent pas une alimentation variée et équilibrée. Femmes enceintes ou allaitantes et personnes sous traitement : demandez conseil à un professionnel de santé.",
        ],
      },
      privacy: {
        h: "Confidentialité",
        p: [
          "Nous collectons uniquement les données nécessaires : votre email et votre nom lors d'une commande, d'un message ou d'une inscription à la newsletter, ainsi que l'adresse de livraison nécessaire à l'expédition de votre colis.",
          "Ces données servent à traiter vos commandes, répondre à vos messages et, si vous y avez consenti, vous envoyer notre newsletter. Elles ne sont ni vendues ni cédées. Vous pouvez demander leur consultation, correction ou suppression depuis votre espace client ou par email.",
          "Le paiement est opéré par Stripe (Stripe Payments Europe Ltd.), soumis à sa propre politique de confidentialité. Les emails transactionnels sont envoyés par notre prestataire d'envoi.",
        ],
      },
    },
    footer: {
      tagline: "Quatre rituels sans sucre ajouté : cacao, café, matcha et golden milk aux extraits de champignons adaptogènes.",
      rights: "© 2026 NŪRA. Tous droits réservés.",
      shop: "Nos rituels",
      explore: "Découvrir",
      info: "Informations",
      securePay: "Paiement sécurisé",
      manageCookies: "Gérer les cookies",
      legal: "Mentions légales",
      shippingPolicy: "Livraison & retours",
      privacy: "Confidentialité",
      account: "Espace client",
    },
  },
  en: {
    nav: { products: "The Range", ritual: "The Ritual", story: "Philosophy", contact: "Contact" },
    cart: "Cart",
    hero: {
      overline: "Adaptogenic Swiss Rituals",
      line1: "Energy",
      line2: "without the crash.",
      line3: "Calm",
      line4: "without the fatigue.",
      sub: "Four drinks, four moments of the day. Short recipes, no added sugar, where cacao, coffee, matcha and spices meet adaptogenic mushroom extracts.",
      cta1: "Discover our range",
      cta2: "Our philosophy",
      badge1: "No added sugar",
      badge2: "5 to 7 ingredients",
      badge3: "Pure extracts",
      quote: "\"A ritual for every moment.\"",
      quoteSub: "Four rituals, four moments",
    },
    marquee: ["No added sugar", "Short recipes: 5 to 7 ingredients", "Pure extracts, no mycelium powder", "Lion's Mane · Cordyceps · Reishi · Tremella", "Free shipping from 50 CHF"],
    products: {
      overline: "The Cycle of the Day",
      title: "A ritual for every moment.",
      add: "Add to cart",
      added: "Added to cart",
      from: "CHF",
      soldOut: "Out of stock",
      soldOutNote: "Back soon — sign up to be notified.",
      preorder: "Pre-order",
      preorderNote: "Pre-order item: shipped as soon as available — you'll be notified by email.",
    },
    checkoutPage: {
      title: "Complete my order",
      step1: "Identification",
      step2: "Shipping address",
      guest: "Check out as guest",
      guestSub: "No account needed — everything arrives by email.",
      login: "I already have an account",
      loginSub: "Reuse your addresses and track your orders.",
      loggedAs: "Signed in as",
      change: "Change",
      phone: "Phone (optional, for the carrier)",
      line1: "Street and number",
      line2: "Additional line (floor, c/o…)",
      zip: "ZIP",
      city: "City",
      country: "Country",
      note: "Delivery note (optional)",
      saveAddress: "Save this address to my account",
      summary: "Summary",
      pay: "Continue to payment",
      step3: "Secure payment",
      edit: "Edit",
      shipTo: "Shipping to",
      secure: "Encrypted payment processed by Stripe (card, TWINT, Apple Pay). No card data passes through our servers.",
      payUnavailable: "Payment temporarily unavailable — please try again shortly.",
      empty: "Your cart is empty.",
      chOnly: "We currently ship to Switzerland only.",
      subscription: "Monthly subscription",
      promoHint: "Have a promo code? You can enter it at the payment step.",
      reassurance: [
        "100% secure payment — Stripe, 3D Secure",
        "Shipped from Switzerland within 2–3 business days, tracked parcel",
        "Returns accepted within 14 days on unopened pouches",
        "No added sugar — organic erythritol, Maca and lucuma, never refined sugar",
        "Confirmation and tracking emailed at every step",
      ],
    },
    manifesto: {
      overline: "Our Philosophy",
      title: "One cup for every moment of the day.",
      chapters: [
        { num: "01", title: "Where we started", text: "A coffee at 8, a second at 11, a third at 2 — and still the late-afternoon wall. Caffeine does not create energy: it masks tiredness, then everything returns at once. We wanted the opposite of a race for stimulants: one cup per moment of the day, formulated for that exact moment." },
        { num: "02", title: "Zero sugar, no compromise", text: "None of our recipes contains added sugar. Erythritol sweetens with a near-zero energy value, maca brings caramel, lucuma brings vanilla. Short lists of five to seven ingredients, formulated and checked in Switzerland under some of the most demanding food law in the world." },
        { num: "03", title: "Choosing the mushrooms", text: "Our extracts come from the forests of Finland: cold climate, acidic soils, strict European food rules. A mushroom absorbs what surrounds it — so the quality of an extract starts with the quality of the soil and the water. We speak of taste, origin and moment; never of promised effects." },
      ],
    },
    ritual: {
      overline: "The Gesture",
      title: "How to prepare your ritual.",
      steps: [
        { t: "Measure", d: "8 g for a cacao or golden milk, 5 g for Deep Flow, 4 g for the matcha." },
        { t: "Pour", d: "150–200 ml of hot water (80 °C for matcha) or plant milk." },
        { t: "Whisk", d: "15 seconds for a fine foam — the gesture that makes the ritual." },
        { t: "Savour", d: "Morning Focus on waking, Deep Flow before effort, Matcha Zen in the afternoon, Evening Calming at bedtime." },
      ],
    },
    cartDrawer: {
      title: "Your cart",
      empty: "Your cart is empty.",
      emptySub: "Begin your ritual with one of our four formulations.",
      freeShippingReached: "Free shipping in Switzerland",
      freeShippingLeft: (x) => `${x} CHF away from free shipping`,
      promo: "Promo code",
      promoApply: "Apply",
      promoOk: "Code NURA10 applied: −10%",
      promoBad: "Invalid code",
      subtotal: "Subtotal",
      discount: "Discount",
      shipping: "Shipping",
      free: "Free",
      total: "Total (VAT incl.)",
      checkout: "Checkout",
      continueShopping: "Continue shopping",
    },
    checkout: {
      title: "Complete your order",
      demo: "",
      name: "Full name",
      email: "Email",
      address: "Address",
      city: "City",
      zip: "ZIP",
      payment: "Payment method",
      card: "Credit card",
      pay: (x) => `Pay ${x} CHF`,
      back: "Back to cart",
      confirmedTitle: "Thank you for your order!",
      confirmedSub: "Your order is being prepared.",
      orderNum: "Order",
      close: "Close",
      required: "Please fill in all fields",
    },
    contact: {
      overline: "Write to Us",
      title: "A question, a partnership?",
      name: "Your name",
      email: "Your email",
      subject: "Subject",
      subjects: ["Product enquiry", "Press", "Partnership", "Other"],
      message: "Your message",
      send: "Send message",
      success: "Message sent — we'll reply as soon as possible.",
    },
    newsletter: {
      title: "Join the NŪRA circle",
      sub: "New formulations, restocks and behind the scenes — occasionally, never more than once a month.",
      placeholder: "your@email.ch",
      cta: "Subscribe",
      success: "Welcome to the NŪRA circle.",
      already: "You're already subscribed.",
    },
    sub: {
      once: "One-time purchase",
      monthly: "Monthly subscription",
      perMonth: "/month",
      save: "−10% · Free shipping",
      note: "No commitment — cancel any time from your customer area.",
      cta: "Subscribe",
    },
    stockAlert: {
      title: "Notify me when it's back",
      placeholder: "your@email.ch",
      cta: "Notify me",
      success: "Noted — you'll get an email as soon as it's back in stock.",
      already: "You're already on the list for this product.",
      error: "Error — please try again.",
    },
    crossSell: {
      title: "Complete your cycle",
      add: "Add",
    },
    trust: ["Secure payment by Stripe", "Shipping in Switzerland · free from 50 CHF", "14-day returns (unopened)"],
    account: {
      title: "Customer Area",
      login: "Sign in",
      register: "Create account",
      name: "Full name",
      email: "Email",
      password: "Password (min. 8 characters)",
      loginCta: "Sign in",
      registerCta: "Create my account",
      hint: "Use the email from your orders to find your history.",
      welcome: "Welcome to NŪRA",
      hello: "Hello",
      logout: "Sign out",
      orders: "My orders",
      noOrders: "No orders yet.",
      noOrdersHint: "Your first ritual awaits in the shop.",
      tracking: "Tracking",
      subscription: "Subscription",
      statuses: { confirmed: "Confirmed", preparing: "Preparing", shipped: "Shipped", delivered: "Delivered", cancelled: "Cancelled", refunded: "Refunded" },
      track: "Track my parcel",
      profile: "My shipping address",
      save: "Save",
      saved: "Address saved",
      review: "Leave a review",
      reviewFor: "Your review of",
      reviewPlaceholder: "Taste, preparation, when you drink it… (min. 10 characters)",
      reviewSend: "Publish my review",
      reviewThanks: "Thank you! Your review will appear after moderation.",
      reviewDone: "Review sent",
      reviewPending: "awaiting moderation",
      reviewPublished: "published",
    },
    productPage: {
      back: "Back to the range",
      benefits: "What you will feel",
      ingredients: "Transparent formulation",
      ingredientsNote: "Indicative list — the full legal ingredient list and nutrition facts are printed on the packaging.",
      preparation: "Preparation",
      reviews: "Customer reviews",
      noReviews: "No published review for this product yet. Be the first to share yours.",
    },
    reviews: {
      overline: "Customer Reviews",
      title: "Reviews we read, never invent.",
      intro: "Every review published here was written by a customer and read before publication. The 'Verified purchase' badge means the email matches a delivered order. We neither buy nor invent testimonials.",
      empty: "No published review yet.",
      emptySub: "Tasted our formulations? Leave your review from the product page.",
      verified: "Verified purchase",
    },
    reviewForm: {
      cta: "Leave a review",
      note: "Your review will be read before publication. If your email matches a delivered order, it will carry the 'Verified purchase' badge. Only your first name and last initial are shown.",
      name: "Your name",
      email: "Your email (not published)",
      placeholder: "Taste, preparation, when you drink it… (min. 10 characters)",
      send: "Send my review",
      thanks: "Thank you! Your review will appear after moderation.",
      error: "Error — please try again.",
    },
    payment: {
      verifying: "Verifying payment…",
      successTitle: "Thank you for your order!",
      successSub: "Your order is being prepared. A confirmation email has been sent to you.",
      accountHint: "Track your parcel and leave a review after delivery: create an account with the email used at checkout.",
      orderNum: "Order",
      errorTitle: "Payment not confirmed",
      errorSub: "We couldn't confirm your payment. Contact us if you were charged.",
      cancelTitle: "Payment cancelled",
      cancelSub: "Your cart is waiting — nothing was charged.",
      backHome: "Back to the shop",
    },
    info: {
      title: "Information",
      lead: "The essentials in three blocks: how we ship, who publishes this site, and what we do with your data. Full documents are linked inside each block.",
      foot: "Foodstuffs. The full legal ingredient list, allergens and nutrition facts appear on every pack. Our descriptions are not health claims.",
      shipping: {
        h: "Shipping & returns",
        p: [
          "We ship from Switzerland. Shipping costs 7 CHF and is free from 50 CHF (after any discount). Subscriptions always ship free.",
          "Orders are prepared within 1–2 business days and handed to Swiss Post. You receive a confirmation email at payment, then a second email with the tracking number when the parcel leaves. Tracking is also visible in your customer area.",
          "Returns: you have 14 days after receipt to return an unopened pouch in its original packaging. Write to us first via the contact form; refunds are made to the original payment method. For hygiene reasons, opened pouches cannot be taken back. A product damaged on delivery is replaced or refunded.",
        ],
      },
      legal: {
        h: "Legal notice",
        p: [
          "This website is published by NŪRA, canton of Vaud, Switzerland. Operated as a sole proprietorship; a limited liability company is being incorporated. Contact: contact@nura-coffee.com.",
          "Prices are shown in Swiss francs (CHF), VAT included where applicable. Payment is processed by Stripe; NŪRA never stores card data.",
          "Our products are foods, formulated with no added sugar. Descriptions cover composition, taste and the moment of enjoyment — not therapeutic effects. They are not a substitute for a varied, balanced diet. Pregnant or breastfeeding women and people under treatment: seek advice from a healthcare professional.",
        ],
      },
      privacy: {
        h: "Privacy",
        p: [
          "We only collect what is necessary: your email and name when you order, write to us or subscribe to the newsletter, plus the delivery address required to ship your parcel.",
          "This data is used to process your orders, answer your messages and, if you consented, send our newsletter. It is neither sold nor shared. You may request access, correction or deletion from your customer area or by email.",
          "Payment is operated by Stripe (Stripe Payments Europe Ltd.), subject to its own privacy policy. Transactional emails are sent by our email provider.",
        ],
      },
    },
    footer: {
      tagline: "Four rituals with no added sugar: cacao, coffee, matcha and golden milk with adaptogenic mushroom extracts.",
      rights: "© 2026 NŪRA. All rights reserved.",
      shop: "Our rituals",
      explore: "Explore",
      info: "Information",
      securePay: "Secure payment",
      manageCookies: "Manage cookies",
      legal: "Legal notice",
      shippingPolicy: "Shipping & returns",
      privacy: "Privacy",
      account: "Customer area",
    },
  },
};
